"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const validator = require("validator");
const react_redux_1 = require("react-redux");
const utils_1 = require("../../utils");
const constants_1 = require("../../constants");
const LandingStore_1 = require("../LandingStore");
const LandingActions_1 = require("../LandingActions");
const util_1 = require("util");
const api_1 = require("../../api");
const AuthenticationActions_1 = require("../../authentication/AuthenticationActions");
const react_bootstrap_1 = require("react-bootstrap");
const LoadableButton_1 = require("../../shared/LoadableButton");
const mapDispatchToProps = dispatch => {
    return {
        openModal: modal => dispatch(LandingActions_1.openModal(modal)),
        loginSuccess: data => dispatch(AuthenticationActions_1.loginSuccess(data))
    };
};
class LoginDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            state: constants_1.ProgressState.None,
            emailField: utils_1.FormUtils.FormFieldStateNone,
            passwordField: utils_1.FormUtils.FormFieldStateNone,
            errorBlock: utils_1.FormUtils.FormFieldStateNone,
            rememberMeField: false
        };
    }
    render() {
        return React.createElement(react_bootstrap_1.Modal, { show: true, onHide: () => {}, className: "landing-modal" }, React.createElement(react_bootstrap_1.Modal.Body, { className: "landing-modal-body" }, React.createElement(react_bootstrap_1.Panel, { className: "login-panel" }, React.createElement("div", { className: "modal-close" }, React.createElement("a", { href: "javascript:void(0)", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Closed);
            } }, "Close")), React.createElement("div", { className: "userpic" }, React.createElement("img", { src: "../img/default_profile.png", alt: "" })), React.createElement("div", { className: "panel-body" }, React.createElement("h2", { className: "text-center" }, "Please Sign In"), React.createElement("div", { className: "text-center has-error" }, this.state.state === constants_1.ProgressState.Failed && utils_1.FormUtils.showErrorBlock(this.state.errorBlock)), React.createElement("fieldset", null, React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "email" }, utils_1.FormUtils.formGroupAttributes(this.state.emailField)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "E-mail", "data-cy": "login_email_input", name: "email", type: "email", onKeyPress: event => this.handleKeyPress(event), onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.emailField)), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "password" }, utils_1.FormUtils.formGroupAttributes(this.state.passwordField)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Password", name: "password", "data-cy": "login_password_input", type: "password", onKeyPress: event => this.handleKeyPress(event), onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.passwordField)), React.createElement(react_bootstrap_1.Checkbox, { onChange: event => {
                utils_1.FormUtils.dataChanged(event, this);
                this.setState({ rememberMeField: !this.state.rememberMeField });
            }, name: "remember", checked: !this.state.rememberMeField }, "Remember Me"), React.createElement("br", null), React.createElement(LoadableButton_1.default, { "data-cy": "login_btn", className: "modal-button", bsStyle: "primary", isLoading: this.state.state === constants_1.ProgressState.Loading, text: "Sign in", onClick: () => this.login() })), React.createElement("br", null), React.createElement("br", null), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 6 }, React.createElement("a", { href: "javascript:void(0)", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.ForgotPassword);
            } }, "Forgot password?")), React.createElement(react_bootstrap_1.Col, { xs: 6, className: "text-right" }, React.createElement("a", { href: "javascript:void(0)", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Register);
            } }, "Sign up now!")))))));
    }
    handleKeyPress(target) {
        if (target.charCode == 13) {
            if (target.target.name == "email") {
                $("#password").focus();
            } else {
                this.login();
            }
        }
    }
    login() {
        if (this.isValid()) {
            this.setState({ state: constants_1.ProgressState.Loading }, () => {
                api_1.doPost(api_1.API.v1.LOGIN, {
                    email: this.email,
                    password: this.password,
                    remember: this.remember
                }, false).then(response => {
                    this.setState({ state: constants_1.ProgressState.Success }, () => {
                        this.props.loginSuccess({
                            user: response.data.user,
                            accessToken: response.data.access_token,
                            socials: response.data.socials,
                            organization: response.data.user.organization
                        });
                        if (response.data.user.isSimplyfied) {
                            window.location.href = "/" + response.data.user.organization.routePrefix + "/app/" + response.data.businessId + "/customers/sms";
                        } else {
                            window.location.href = "/" + response.data.user.organization.routePrefix + "/app";
                        }
                    });
                }).catch(error => {
                    api_1.dispatchError(error, () => {
                        this.handleErrors(error.response.data);
                    });
                });
            });
        }
    }
    isValid() {
        let valid = true;
        let updateState = this.state;
        if (util_1.isNullOrUndefined(this.email) || validator.isEmpty(this.email)) {
            updateState.emailField = { state: constants_1.ProgressState.Failed, errorMessage: "Email can't be blank." };
            valid = false;
        } else if (!validator.isEmail(this.email)) {
            updateState.emailField = { state: constants_1.ProgressState.Failed, errorMessage: "Not valid email format." };
            valid = false;
        } else {
            updateState.emailField = { state: constants_1.ProgressState.Success };
        }
        if (util_1.isNullOrUndefined(this.password) || validator.isEmpty(this.password)) {
            updateState.passwordField = { state: constants_1.ProgressState.Failed, errorMessage: "Password can't be blank." };
            valid = false;
        } else {
            updateState.passwordField = { state: constants_1.ProgressState.Success };
        }
        this.setState(updateState);
        return valid;
    }
    handleErrors(errors) {
        if (!util_1.isNullOrUndefined(errors)) {
            let updateState = this.state;
            errors.forEach(error => {
                if (error.reason == "LOGIN_FAILED") {
                    updateState.passwordField = {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: ""
                    };
                    updateState.emailField = {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: ""
                    };
                    updateState.errorBlock = {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: "Email or password was incorrect"
                    };
                    updateState.state = constants_1.ProgressState.Failed;
                } else if (error.reason == "USER_NOT_ACTIVATED") {
                    updateState.passwordField = {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: ""
                    };
                    updateState.emailField = {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: ""
                    };
                    updateState.errorBlock = {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: "User not activated"
                    };
                    updateState.state = constants_1.ProgressState.Failed;
                }
            });
            this.setState(updateState);
        }
    }
}
exports.default = react_redux_1.connect(null, mapDispatchToProps)(LoginDialog);


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/components/LoginDialog.tsx
// module id = 1059
// module chunks = 0 1